(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSceneCarousel);
  } else {
    setTimeout(initProductSceneCarousel, 50);
  }
  
  function initProductSceneCarousel() {
    const carousels = document.querySelectorAll('[id^="product-scene-carousel-"]');
    if (!carousels.length) return;
    carousels.forEach(carousel => {
      try {
        new ProductSceneCarousel(carousel);
      } catch (error) {
        console.error('Error initializing carousel:', error);
      }
    });
  }
  
  function isMobileDevice() {
    return window.innerWidth <= 767;
  }
  
  class ProductSceneCarousel {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.data = window.productSceneCarouselData?.[this.sectionId];
      
      if (!this.data) return;
      
      this.currentIndex = this.data.currentIndex || 0;
      this.images = this.data.blocks || [];
      
      this.mainImage = container.querySelector(`#main-image-${this.sectionId}`);
      this.prevBtn = container.querySelector('.prev-btn');
      this.nextBtn = container.querySelector('.next-btn');
      this.thumbnails = container.querySelectorAll('.thumbnail-item');
      
      if (!this.mainImage || !this.prevBtn || !this.nextBtn) return;
      
      this.setInitialImagesForDevice();
      this.applySettings();
      this.bindEvents();
      
      // ✅ 修改点 1：初始化时传入 true，表示这是静默初始化
      this.updateUI(this.currentIndex, true);
      this.preloadAllImages();
    }
    
    setInitialImagesForDevice() {
      const isMobile = isMobileDevice();
      const currentImage = this.images[this.currentIndex];
      if (currentImage && this.mainImage) {
        this.mainImage.src = isMobile ? (currentImage.image_mobile || currentImage.image_desktop) : currentImage.image_desktop;
      }
      this.updateAllThumbnailImages();
    }
    
    updateAllThumbnailImages() {
      if (!this.thumbnails) return;
      const isMobile = isMobileDevice();
      this.thumbnails.forEach((thumb, index) => {
        const thumbImg = thumb.querySelector('img');
        if (!thumbImg) return;
        const imgData = this.images[index];
        if (imgData) {
          thumbImg.src = isMobile ? (imgData.image_mobile || imgData.image_desktop) : imgData.image_desktop;
        }
      });
    }

    preloadAllImages() {
      this.images.forEach(imgData => {
        const desktop = new Image(); desktop.src = imgData.image_desktop;
        if(imgData.image_mobile) { const mobile = new Image(); mobile.src = imgData.image_mobile; }
      });
    }
    
    applySettings() {
      const highlightColor = this.container.dataset.highlightColor || '#ff8d00';
      this.container.style.setProperty('--highlight-color', highlightColor);
    }
    
    bindEvents() {
      this.thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToSlide(index);
        });
      });
      
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.prevSlide();
      });
      
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide();
      });
      
      this.resizeHandler = () => this.handleResize();
      window.addEventListener('resize', this.resizeHandler);
    }
    
    handleResize() {
      const isMobile = isMobileDevice();
      if (this.isMobile !== isMobile) {
        this.isMobile = isMobile;
        this.setInitialImagesForDevice();
      }
      this.adjustThumbnailsLayout();
    }
    
    goToSlide(index) {
      if (index < 0 || index >= this.images.length || index === this.currentIndex) return;
      this.currentIndex = index;
      // ✅ 修改点 2：手动切换时，不传参（默认为 false），执行正常滚动对齐
      this.updateUI(index);
    }

    updateUI(index, isInitial = false) {
      this.updateMainImage();
      this.updateThumbnails(index, isInitial); // 传递初始化标志
      this.adjustThumbnailsLayout(); 
    }
    
    updateMainImage() {
      const isMobile = isMobileDevice();
      const currentImage = this.images[this.currentIndex];
      const imageUrl = isMobile ? (currentImage.image_mobile || currentImage.image_desktop) : currentImage.image_desktop;
      
      this.mainImage.style.opacity = '0.4';
      const tempImg = new Image();
      tempImg.src = imageUrl;
      tempImg.onload = () => {
        this.mainImage.src = imageUrl;
        this.mainImage.style.opacity = '1';
      };
    }
    
    prevSlide() {
      const newIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.goToSlide(newIndex);
    }
    
    nextSlide() {
      const newIndex = (this.currentIndex + 1) % this.images.length;
      this.goToSlide(newIndex);
    }
    
    // ✅ 修改点 3：增加 isInitial 判断逻辑
    updateThumbnails(activeIndex, isInitial = false) {
      this.thumbnails.forEach((thumb, index) => {
        if (index === activeIndex) {
          thumb.classList.add('thumbnail-active');
          // 只有在非初始化（即用户手动点击或按钮切换）时，才执行滚动对齐
          if (!isInitial) {
            thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        } else {
          thumb.classList.remove('thumbnail-active');
        }
      });
    }
    
    adjustThumbnailsLayout() {
      if (!this.thumbnails.length || window.innerWidth <= 767) {
        this.thumbnails.forEach(t => { t.style.minWidth = ''; t.style.maxWidth = ''; t.style.height = ''; });
        return;
      }
      
      const container = this.container.querySelector('.thumbnails-wrapper');
      if (!container) return;
      
      const thumbCount = this.thumbnails.length;
      const gap = 15;
      const containerWidth = container.offsetWidth;
      const totalWeight = (thumbCount - 1) + 1.2;
      const baseUnit = (containerWidth - (gap * (thumbCount - 1))) / totalWeight;

      this.thumbnails.forEach((thumb, index) => {
        const isActive = thumb.classList.contains('thumbnail-active');
        const width = isActive ? baseUnit * 1.2 : baseUnit;
        const height = (width * 275) / 635;
        
        thumb.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
        thumb.style.minWidth = `${width}px`;
        thumb.style.maxWidth = `${width}px`;
        thumb.style.height = `${height}px`;
        thumb.style.opacity = isActive ? '1' : '0.6';
      });
    }
  }
  
  window.ProductSceneCarousel = ProductSceneCarousel;
})();